/**
 * Códigos IATA de las aerolíneas que operan en Cancún, indexados por su nombre
 * normalizado (ver normalizarAerolinea).
 *
 * El sistema no guarda el código de la aerolínea: `aerolinea` es el nombre que
 * devuelve AeroDataBox y `vuelo` ya trae el código cuando se elige del buscador
 * ("VB 2180"). Solo las capturas manuales guardan el número suelto ("2180"), y
 * para esas se completa el código a partir del nombre (TQO-314)
 */
const CODIGOS_IATA = {
  aeromexico: 'AM',
  aircanada: 'AC',
  aireuropa: 'UX',
  airfrance: 'AF',
  airtransat: 'TS',
  alaska: 'AS',
  allegiant: 'G4',
  american: 'AA',
  arajet: 'DM',
  avianca: 'AV',
  breeze: 'MX',
  british: 'BA',
  condor: 'DE',
  copa: 'CM',
  delta: 'DL',
  discover: '4Y',
  edelweiss: 'WK',
  eurowings: 'EW',
  flair: 'F8',
  frontier: 'F9',
  iberia: 'IB',
  jetblue: 'B6',
  klm: 'KL',
  latam: 'LA',
  lufthansa: 'LH',
  magnicharters: 'UJ',
  mexicana: 'XN',
  mexicanadeaviacion: 'XN',
  porter: 'PD',
  southwest: 'WN',
  spirit: 'NK',
  suncountry: 'SY',
  sunwing: 'WG',
  tui: 'BY',
  turkish: 'TK',
  united: 'UA',
  virginatlantic: 'VS',
  vivaaerobus: 'VB',
  volaris: 'Y4',
  westjet: 'WS',
  wingo: 'P5',
  world2fly: '2W',
}

// Sufijos que AeroDataBox añade o no según la aerolínea ("American Airlines" / "American")
// Las claves de CODIGOS_IATA se guardan ya normalizadas, es decir, sin estos sufijos:
// "British Airways" se busca como `british` (TQO-314)
const SUFIJOS = ['airlines', 'airline', 'airways', 'lineasaereas']

/**
 * Normaliza el nombre de una aerolínea: minúsculas, sin acentos, sin espacios ni
 * signos y sin sufijos genéricos.
 * @param {string} nombre - El nombre de la aerolínea.
 * @return {string} El nombre normalizado.
 */
function normalizarAerolinea(nombre) {
  const base = String(nombre || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
  const sufijo = SUFIJOS.find((s) => base.endsWith(s) && base.length > s.length)
  return sufijo ? base.slice(0, -sufijo.length) : base
}

/**
 * Devuelve el número de vuelo con el código IATA de la aerolínea delante.
 * Solo lo añade cuando el vuelo son solo dígitos; si ya trae código, o la
 * aerolínea no está en la tabla, lo devuelve tal cual.
 * @param {string} aerolinea - El nombre de la aerolínea.
 * @param {string} vuelo - El número de vuelo guardado.
 * @return {string} El vuelo con código IATA cuando se puede completar.
 */
export function vueloConCodigoIata(aerolinea, vuelo) {
  if (vuelo === null || vuelo === undefined) return vuelo
  const numero = String(vuelo).trim()
  if (!/^\d+$/.test(numero)) return vuelo

  const codigo = CODIGOS_IATA[normalizarAerolinea(aerolinea)]
  return codigo ? `${codigo} ${numero}` : vuelo
}
